<template>
    <div class="delete-modal">
        <b-modal
            no-enforce-focus
            centered
            hide-header
            hide-footer
            id="modal-delete-event-venue"
            content-class="cancel-event-modal"
            size="xl"
        >
            <p class="modal-title-text">You are about to delete this event</p>
            <p class="modal-warning-text">Are you sure you want to delete this event?</p>
            <div class="action-btns">
                <button class="return-btn" @click="$bvModal.hide('modal-delete-event-venue')">
                    No, Let's Go Back
                </button>
                <button
                    class="cancel-btn"
                    @click="() => deleteEvent(currentEvent.id)"
                    slot="modal-footer"
                >
                    Yes, Delete This Event
                </button>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { api } from '@/helpers/api'

    export default {
        name: 'DeleteModal',
        props: {
            currentEvent: {
                type: Object,
                required: true
            }
        },
        methods: {
            async deleteEvent(id) {
                await api({
                    method: 'delete',
                    url: '/api/event/manage/' + id + '/delete'
                })
                this.$bvModal.hide('modal-delete-event-venue')
                window.location.href = '/booking-manager'
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }
    .modal-title-text {
        color: #f5f5f5;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        text-align: center;
    }
    .modal-warning-wrapper {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        max-width: 620px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .modal-warning-text {
        color: #acacac;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        text-align: center;
    }
    .action-btns {
        display: flex;
        flex-direction: column;
        align-items: center;

        .cancel-btn {
            color: #8b8b8b;
            text-align: center;
            font-family: 'Instrument Sans';
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 120%;
            text-decoration-line: underline;
            background: none;
        }
        .return-btn {
            padding: 11px 30px 12px 30px;
            border-radius: 100px;
            background: #cdeb09;
            color: #000;
            font-family: 'Instrument Sans';
            font-size: 18px;
            font-style: normal;
            font-weight: 650;
            line-height: 120%;
            border: 0;
            max-height: 90px;
            margin-bottom: 24px;
            margin-top: 40px;
        }
    }
</style>
